// extracted by mini-css-extract-plugin
export default {"mega_dropdown":"SectionFIlters_mega_dropdown__NsJRl"};